import { CheckboxRootProps } from '@chakra-ui/react'
import { Checkbox as ChakraCheckbox } from '@web/components/chakra-ui/checkbox'
import { forwardRef } from 'react'

const Checkbox = forwardRef((props: CheckboxRootProps, ref: React.Ref<HTMLInputElement>) => {
  return <ChakraCheckbox ref={ref} {...props} />
})

export default Checkbox
